import { UserCheck, Compass, BookOpenText, Eye, Zap, HeartHandshake } from "lucide-react";

const REASONS = [
  { icon: UserCheck, title: "Pembimbing Berpengalaman", desc: "Tim pembimbing bersertifikat dengan pengalaman lebih dari 10 tahun." },
  { icon: Compass, title: "Pendampingan Terarah", desc: "Pendampingan terstruktur mulai dari pendaftaran hingga kepulangan." },
  { icon: BookOpenText, title: "Manasik Teori & Praktik", desc: "Metode pembelajaran gabungan teori dan simulasi lapangan." },
  { icon: Eye, title: "Informasi Transparan", desc: "Seluruh progres, dokumen, dan pembayaran dapat dipantau langsung." },
  { icon: Zap, title: "Pelayanan Responsif", desc: "Tim admin siap membantu pertanyaan Anda dengan cepat." },
  { icon: HeartHandshake, title: "Pendekatan Humanis", desc: "Setiap jamaah dilayani dengan penuh kesabaran dan empati." },
];

export default function WhyUs() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-testid="why-us-section">
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">Mengapa Memilih Kami</span>
        <h2 className="mt-3 font-heading text-3xl font-bold text-[#1F2937] sm:text-4xl">Mengapa KBIHU Muhammadiyah Surabaya</h2>
      </div>
      <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {REASONS.map((r) => (
          <div key={r.title} data-testid={`why-us-${r.title.toLowerCase().replace(/\s+/g, "-")}`} className="flex gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-[#0F6B4F] to-[#1677B8] text-white">
              <r.icon className="h-6 w-6" />
            </div>
            <div>
              <h3 className="font-heading text-base font-semibold text-[#1F2937]">{r.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-[#64748B]">{r.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
